import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_CHARGEBACK_STATUS_DEF,
} from "./actionTypes"

import {
    getChargebackStatusDefListSuccess,
    apiChargebackStatusDefApiError
} from "./actions"

// include backend helper file methods
import {
    getChargebackStatusDefList,
} from "../../helpers/backend_helper/backend_helper"

  function* onGetChargebackStatusDefList() {
    try {
      const response = yield call(getChargebackStatusDefList)
      yield put(getChargebackStatusDefListSuccess(response))
    } catch (error) {
      yield put(apiChargebackStatusDefApiError(error))
    }
  }
  
  function* chargebackStatusDefSaga() {
    yield takeEvery(GET_CHARGEBACK_STATUS_DEF, onGetChargebackStatusDefList)
  }
  
  export default chargebackStatusDefSaga